var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStSymbolId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.69 39.69",
    enableBackground: "new 0 0 39.69 39.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#82C047",
    d: "M24.7,27.48l-3.92,6.8c-0.76,1.32,0.11,3.04,1.55,3.04h3.7c0.63,0,1.21-0.35,1.55-0.93l5.54-9.6 c0.62-1.07,0.62-2.44,0-3.51l-5.56-9.62c-0.33-0.58-0.92-0.93-1.55-0.93h-3.66c-1.43,0-2.31,1.71-1.55,3.03l3.92,6.82 C25.56,24.07,25.56,25.98,24.7,27.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82C047",
    d: "M14.99,12.21l3.92-6.8c0.76-1.32-0.11-3.04-1.55-3.04h-3.7c-0.63,0-1.21,0.35-1.55,0.93l-5.54,9.6 c-0.62,1.07-0.62,2.44,0,3.51l5.56,9.62c0.33,0.58,0.92,0.93,1.55,0.93h3.66c1.43,0,2.31-1.71,1.55-3.03l-3.92-6.82 C14.12,15.61,14.13,13.71,14.99,12.21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStSymbolId);
export default __webpack_public_path__ + "static/media/ST_Symbol_ID.244105544ac4f9c429ec1b4fab13448b.svg";
export { ForwardRef as ReactComponent };